import { jsx } from '@emotion/react';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { buildUpgradeUrl } from './utils';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
export const shouldRender = (data) => {
    const { isTeamAccount, teamTrialEndDate } = data.currentAccount;
    return (!isTeamAccount && !!teamTrialEndDate && daysFromNow(teamTrialEndDate) <= 7);
};
export const Component = function TeamsTrialEnded(props) {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data } = props;
    const upgradeUrl = buildUpgradeUrl({
        upgradePlanId: (_a = data.nextTeamPlan) === null || _a === void 0 ? void 0 : _a.id,
    });
    return (jsx(Alert, { variant: props.variant, title: "Your Team trial has ended", status: "info" },
        jsx(Link, { href: getFullyQualifiedURL(upgradeUrl) }, "Upgrade"),
        "\u00A0to keep your access to unlimited users, shared app connections, premier support, and more"));
};
//# sourceMappingURL=TeamsTrialEnded.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
